import { campoDeveSerMaiorQueZero, campoObrigatorio } from 'helpers/Constantes/Mensagens'

export type DadosLoteamentoComercial = {
  quantidadeUnidades: string
  quantidadePermutas: string
  areaLote: string
  precoTabela: string
  valido: boolean
}

export const dadosLoteamentoComercialValorDefault = {
  quantidadeUnidades: '',
  quantidadePermutas: '',
  areaLote: '',
  precoTabela: '',
  valido: true
} as DadosLoteamentoComercial

export class ValidacaoLoteamentoComercial {
  quantidadeUnidades: string
  areaLote: string
  precoTabela: string

  constructor(quantidadeUnidades = '', areaLote = '', precoTabela = '') {
    this.quantidadeUnidades = quantidadeUnidades
    this.areaLote = areaLote
    this.precoTabela = precoTabela
  }

  validarQuantidadeUnidades(quantidadeUnidades: string): string {
    let error = ''

    if (!quantidadeUnidades || quantidadeUnidades === '') {
      error = campoObrigatorio
    }

    if (parseInt(quantidadeUnidades) === 0) {
      error = campoDeveSerMaiorQueZero
    }

    return error
  }

  validarAreaLote(areaLote: string): string {
    let error = ''

    if (!areaLote || areaLote === '') {
      error = campoObrigatorio
    }

    if (parseInt(areaLote) === 0) {
      error = campoDeveSerMaiorQueZero
    }

    return error
  }

  validarPrecoTabela(precoTabela: string): string {
    let error = ''

    if (!precoTabela || precoTabela === '') {
      error = campoObrigatorio
    }

    if (parseInt(precoTabela) === 0) {
      error = campoDeveSerMaiorQueZero
    }

    return error
  }

  verificarCamposPreenchidos(state: DadosLoteamentoComercial): ValidacaoLoteamentoComercial {
    if (state.quantidadeUnidades != '' || state.quantidadePermutas != '' || state.areaLote != '' || state.precoTabela != '') {
      const msgErroQuantidadeUnidade = this.validarQuantidadeUnidades(state.quantidadeUnidades)
      const msgErroAreaLote = this.validarAreaLote(state.areaLote)
      const msgErroPrecoTabela = this.validarPrecoTabela(state.precoTabela)

      return new ValidacaoLoteamentoComercial(msgErroQuantidadeUnidade, msgErroAreaLote, msgErroPrecoTabela)
    }

    return new ValidacaoLoteamentoComercial('', '', '')
  }

  validarTodosCampos(): boolean {
    if (this.quantidadeUnidades === '' && this.areaLote === '' && this.precoTabela === '') {
      return true
    }

    return false
  }
}
